/* eslint-disable vue/valid-v-slot */
import { Teaching, Subject, Class, Slot } from '@/plugins/api'
import { chunk, get, rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    teachings: [],
    teaching: {},
    pageText: '',
    itemsPerPage: 10,
    searchParams: {},
    totalItems: 0,
    loading: false
  },
  actions: {
    countIndependent(_, params) {
      return Teaching.countTeaching(params)
    },
    async searchTeachings({ commit, state, dispatch }, query) {
      const searchParams = {
        _limit: state.itemsPerPage,
        ...query
      }

      commit('changeState', { searchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })

      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        let searchParams = {
          ...state.searchParams
        }
        searchParams = {
          ...searchParams,
          class_null: false,
          subject_null: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'tags:ASC'
        }
        const [totalItems, teachings] = await Promise.all([
          Teaching.countTeaching(searchParams),
          Teaching.searchTeaching(searchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            teachings,
            totalItems,
            itemsPerPage,
            searchParams
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('changeState', { pageText })
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async searchTeaching({ commit, state, dispatch }, query) {
      try {
        const subject = await Subject.fetch({
          _limit: -1,
          id: query.subject,
          grade: query.grade,
          subjectGroup: query.subjectGroup
        })
        const classQuery = {
          _limit: -1,
          id: query.class,
          grade: query.grade,
          status: 'running'
        }
        const classes = await Class.fetch(classQuery)
        const teachings = await Teaching.fetch({
          _limit: -1,
          teacher: query.teacher
        })
        let teachingsTemp = []
        classes.map(c => {
          if (!c.grade) return
          subject.map(s => {
            if (!s.division || !c.division || get(s.division, 'id') !== get(c.division, 'id')) return
            const teaching = teachings.filter(t => t.subject.id === s.id && t.class.id === c.id)
            const teachingData = { grade: c.grade, class: c, subject: s, teacher: null }
            if (teaching.length > 0) {
              teaching.map(m => {
                teachingsTemp = [...teachingsTemp, { ...teachingData, teacher: m.teacher, id: m.id }]
              })
            } else if (!query.teacher) {
              teachingsTemp = [...teachingsTemp, teachingData]
            }
          })
        })
        commit('setTeachings', teachingsTemp)
      } catch (e) {
        this.$alert.error(e.message)
      } finally {
      }
    },
    async fetchTeachings({ commit }, options) {
      const teachings = await Teaching.fetch({ ...options, _limit: -1 })
      return teachings
    },

    async fetchTeaching({ commit }, teachingId) {
      const teaching = await Teaching.fetchOne(teachingId)
      commit('setTeaching', teaching)
    },
    async createTeaching({ state, dispatch }, teachingData) {
      await Teaching.create(teachingData)
    },
    async removeTeaching({ commit }, teachingId) {
      // remove slot
      const slots = await Slot.fetch({ teaching: teachingId, _limit: -1 })
      if (slots && slots.length) {
        const groups = chunk(slots, 5)
        for (const subSlots of groups) {
          const promises = subSlots.map(slot => Slot.remove(slot.id))
          await Promise.all(promises)
        }
      }

      await Teaching.remove(teachingId)
      commit('removeTeaching', teachingId)
    },
    async updateTeaching({ commit }, { id, ...teaching }) {
      const t = await Teaching.update(id, teaching)
      // update slot
      let teacher = null
      if (t.teacher && t.teacher.id) teacher = t.teacher.id

      const slots = await Slot.fetch({ teaching: t.id, _limit: -1 })
      if (slots && slots.length) {
        const groups = chunk(slots, 5)
        for (const subSlots of groups) {
          const promises = subSlots.map(slot =>
            Slot.update(slot.id, {
              teacher
            })
          )

          await Promise.all(promises)
        }
      }
      commit('setTeaching', t)
    }
  },
  mutations: {
    setTeaching(state, teaching) {
      const teachings = state.teachings.map(t => {
        if (t.id === teaching.id) {
          return teaching
        } else return t
      })
      state.teachings = teachings
    },
    removeTeaching(state, teacherId) {
      state.teachings = state.teachings.filter(t => {
        return t.id !== teacherId
      })
    },
    setTeachings(state, teachings) {
      state.teachings = teachings
    }
  }
}
